<script setup>
import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const emit = defineEmits(['update:modelValue', 'update:focused']);
defineProps({
    hideLabel: {
        type: Boolean,
        default: false
    }
});

const selected = ref(null);

const statuses = computed(() => [
    { title: t('twilio_actions.new_invoice'), value: 'new_invoice' },
    { title: t('twilio_actions.new_customer'), value: 'new_customer' },
    { title: t('twilio_actions.new_warehouse'), value: 'new_warehouse' },
    { title: t('twilio_actions.new_guide'), value: 'new_guide' },
    { title: t('twilio_actions.new_package'), value: 'new_package' },
    { title: t('twilio_actions.new_pickup'), value: 'new_pickup' },
    { title: t('twilio_actions.status_change'), value: 'status_change' },
    { title: t('twilio_actions.completation'), value: 'completation' },
    { title: t('twilio_actions.new_qinvoice'), value: 'new_qinvoice' }
]);
</script>

<template>
    <v-select
        v-model="selected"
        :items="statuses"
        item-title="title"
        item-value="value"
        :label="hideLabel ? '' : 'Action'"
        density="compact"
        hide-details
        clearable
        persistent-clear
        @update:modelValue="emit('update:modelValue', selected)"
        @update:focused="(state) => emit('update:focused', state)"
    >
    </v-select>
</template>
